//    ╔═╗┌─┐┌┐┌┌─┐┬ ┬┌┬┐┌─┐  ┌┬┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐  ┬ ┬┌─┐┌┐ 
//    ║  │ ││││└─┐│ │││││ │   ││├┤   └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐  │││├┤ ├┴┐
//    ╚═╝└─┘┘└┘└─┘└─┘┴ ┴└─┘  ─┴┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘  └┴┘└─┘└─┘

import {Injectable} from '@angular/core';
import {Auditoria} from './../modelo/auditoria';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class AuditoriaService {

    constructor(private http: Http) {
    }

    getAuditoria(): any {
        var lista: Auditoria[] = [
            new Auditoria(1, "Rodolfo", "Rivas", "Escontech", "ACTIVO")
        ];
        return lista;

    }

    /*consultarAuditoria(id):any{
      var auditoria:Auditoria;
      auditoria = new Auditoria(1,"Carlos","Garibaldi","Escontech","ACTIVO";
      
      return auditoria;
  
    }*/
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/auditoria/recursos/servicios/auditoria.service.ts